import { Injectable } from '@angular/core';
import { BaseService, LeagueNews, LeagueNewsApi, LeagueNewsType } from '@mtgame/core';
import { LeagueRootService } from '@core/services/league-root.service';
import { Observable } from 'rxjs';

const STORE_NEWS_KEY = 'news';

@Injectable({providedIn: 'root'})
export class LeagueNewsService extends BaseService {
  page = 1;
  size = 30;
  total: number;
  leagueId: number;

  get news$(): Observable<LeagueNews[]> {
    return this.store.get(STORE_NEWS_KEY);
  }

  constructor(
    private leagueRootService: LeagueRootService,
    private leagueNewsApi: LeagueNewsApi,
  ) {
    super();
  }

  async initialize(): Promise<LeagueNews[]> {
    const league = this.leagueRootService.getLeagueModel();
    this.leagueId = league.id;
    this.page = 1;
    return this.loadNews();
  }

  async loadNews(): Promise<LeagueNews[]> {
    const news = await this.leagueNewsApi.getLeagueNewsList(this.leagueId, this.page, this.size, LeagueNewsType.text);
    if (this.page === 1) {
      this.store.save(STORE_NEWS_KEY, news.data);
      this.total = news.total;
    } else {
      this.store.appendItems(STORE_NEWS_KEY, news.data);
    }
    return news.data;
  }

  async loadNextPage(): Promise<LeagueNews[]> {
    if (this.page * this.size >= this.total) {
      return Promise.resolve([]);
    }
    this.page++;
    return this.loadNews();
  }
}
